module.exports = __webpack_public_path__ + "img/bt1.c793548b.png";